import Vue from 'vue';

function formatMoney(number) {
  return formatMoneyWithFraction(number, 2);
}

function formatMoneyWithFraction(number, fraction) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fraction,
  });
  return formatter.format(number);
}

Vue.filter('formatMoney', (number) => {
  return formatMoney(number);
});

Vue.filter('formatMoneyWithFraction', (number, fraction) => {
  return formatMoneyWithFraction(number, fraction);
});

Vue.filter('formatNumber', (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
});

Vue.filter('formatMoneyWithSign', (number) => {
  const money = formatMoney(number);
  if (number > 0) {
    return '+' + money;
  }
  return money;
});

function addDateZeroPrefix(val) {
  if (val >= 10) {
    return val;
  }
  return `0${val}`;
}

Vue.filter('formatDateYmd', (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}-${addDateZeroPrefix(month)}-${addDateZeroPrefix(day)}`;
});

Vue.filter('formatPercent', (val, fractionDigits = 3) => {
  return `${val.toFixed(fractionDigits)}%`;
});
